export default {
    getStatusClass(status) {
        const map = {
            Pending: 'warning',
            Approved: 'success',
            Disapproved: 'danger',
        };

        return `badge badge-${map[status]} text-white`;
    },
};
